import axios from 'axios';
import store from '../store';
import msalAuth from './msalAuth';
import configs from '../configs';

const create = () => {
  const instance = axios.create({
    baseURL: configs.API_URL,
    timeout: 300000,
  });

  instance.interceptors.request.use(
    (config) => {
      const token = store.state.token.accessToken; // Get the latest access token from Vuex
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`; // Set the Authorization header
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    async error => {
      if (error.response) {

        if (error.response.status === 401) {
          const originalRequest = error.config;
          if (!originalRequest._retry) {
            originalRequest._retry = true;
            await msalAuth.getTokenPopup();
            const newToken = store.state.token.accessToken;
            originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
            return instance(originalRequest);
          }
        } else if (error.response.status === 403) {
          // eslint-disable-next-line no-console
          console.error('Unauthorized');
        }
      } else if (error.request) {
        // eslint-disable-next-line no-console
        console.error('No response received:', error.request);
      } else {
        // eslint-disable-next-line no-console
        console.error('Request error:', error.message);
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

export default {
  create,
};
